export function calculateInvoicesPercentages(invoices, totalAmount) {
  if (totalAmount === 0) {
    return [];
  }
  return Object.entries(invoices).map(_ref => {
    let [invoiceType, value] = _ref;
    return {
      type: invoiceType,
      count: value.count,
      amount: value.amount,
      percentage: value.amount.amount().div(totalAmount).mul(100).toNumber()
    };
  });
}
export const invoiceTypeToTooltip = count => {
  const isMany = count > 1;
  const hasOrHave = isMany ? 'have' : 'has';
  const requireOrRequires = isMany ? 'require' : 'requires';
  const isOrAre = isMany ? 'are' : 'is';
  return {
    failed: "".concat(hasOrHave, " failed to process payment."),
    requiresClientApproval: "".concat(requireOrRequires, " client approval process payment."),
    paymentsVerificationRequired: "".concat(requireOrRequires, " payment verification process payment."),
    missingPaymentMethod: "".concat(isOrAre, " missing payment method to process payment."),
    paymentStopped: "".concat(hasOrHave, " their payment stopped."),
    disputed: "".concat(hasOrHave, " been disputed.")
  };
};